module.exports = __webpack_public_path__ + "static/magnet@2x-07f8044cc3b13b458ce8398af4c2249b.png";